import React, { useEffect, useState } from "react";
import userAPI from "../../api/UserApi";
import { showError } from "../../utils/toastUtils";
import { Link } from "react-router-dom";
import { getDateAgo } from "../../helper/Helper";

import {
  ShoppingBag,
  ArrowRight,
  CalendarDays,
  IndianRupee,
  PackageCheck,
} from "lucide-react";

function Orders() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    fetchMyOrders();
  }, []);

  const fetchMyOrders = async () => {
    try {
      const res = await userAPI.fetchMyOrders();

      if (res.code === 200) {
        setOrders(res.data);
      }
    } catch (err) {
      showError(err.message);
    }
  };

  const getStatusClass = (status) => {
    const value = status?.toLowerCase();

    if (
      value === "delivered" ||
      value === "completed" ||
      value === "success"
    ) {
      return "status-success";
    }

    if (
      value === "cancelled" ||
      value === "canceled" ||
      value === "failed"
    ) {
      return "status-danger";
    }

    if (
      value === "shipped" ||
      value === "processing" ||
      value === "confirmed"
    ) {
      return "status-info";
    }

    return "status-pending";
  };

  return (
    <div className="custom-orders-page">

      {orders && orders.length > 0 ? (

        <div className="custom-orders-wrap">

          {/* =====================================
              HEADER
          ===================================== */}

          <div className="custom-orders-heading">

            <div className="custom-orders-heading-left">

              <div className="custom-orders-main-icon">
                <ShoppingBag size={20} />
              </div>

              <div>
                <span>ACCOUNT</span>

                <h4>Order History</h4>

                <p>
                  Track and manage your recent orders
                </p>
              </div>

            </div>


            <div className="custom-orders-count">
              <strong>{orders.length}</strong>
              <span>Orders</span>
            </div>

          </div>


          {/* =====================================
              ORDER TABLE
          ===================================== */}

          <div className="custom-orders-table-wrapper">

            <table className="custom-orders-table">

              <thead>
                <tr>
                  <th>Order</th>
                  <th>Date</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th></th>
                </tr>
              </thead>


              <tbody>

                {orders.map((order, index) => (

                  <tr
                    className="custom-order-row"
                    key={order?._id || order?.orderId || index}
                  >

                    {/* ORDER */}

                    <td>

                      <Link
                        to={`/users/order-details/${order.orderId}`}
                        className="custom-order-id"
                      >

                        <span className="custom-order-id-icon">
                          <ShoppingBag size={15} />
                        </span>

                        <span>
                          #{order.orderId}
                        </span>

                      </Link>

                    </td>


                    {/* DATE */}

                    <td>

                      <div className="custom-order-date">

                        <CalendarDays size={15} />

                        <span>
                          {getDateAgo(order?.orderDate)}
                        </span>

                      </div>

                    </td>


                    {/* AMOUNT */}

                    <td>

                      <div className="custom-order-amount">

                        <IndianRupee size={14} />

                        <strong>
                          {order.total}
                        </strong>

                        <span>/-</span>

                      </div>

                    </td>


                    {/* STATUS */}

                    <td>

                      <span
                        className={`custom-order-status-badge ${getStatusClass(
                          order?.status
                        )}`}
                      >

                        <span className="custom-status-dot"></span>

                        {order?.status?.toUpperCase()}

                      </span>

                    </td>


                    {/* DETAIL */}

                    <td className="custom-order-detail-cell">

                      <Link
                        to={`/users/order-details/${order.orderId}`}
                        className="custom-order-detail-btn"
                      >
                        View
                        <ArrowRight size={14} />
                      </Link>

                    </td>

                  </tr>

                ))}

              </tbody>

            </table>

          </div>

        </div>

      ) : (

        /* =====================================
           EMPTY ORDERS
        ===================================== */

        <div className="custom-orders-empty">

          <div className="custom-empty-order-icon">
            <PackageCheck size={32} />
          </div>

          <h4>No orders yet</h4>

          <p>
            You haven’t placed any order yet.
            <br />
            It’s time to make your first purchase.
          </p>

          <Link
            to="/shop"
            className="custom-orders-shop-btn"
          >
            Start Shopping
            <ArrowRight size={16} />
          </Link>

        </div>

      )}

    </div>
  );
}

export default Orders;